<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Document Distributor">
     Document Distributor
    </a>
   </p>
   <p class="toc-1-style">
    <a href="lexmark-document-distributor-overview.html#lexmark-document-distributor-overview" title="Overview">
     Overview
    </a>
   </p>
   <div id="divd0e10">
    <p class="toc-2-style">
     <a href="lexmark-document-distributor-overview.html#understanding-stages-of-job" title="Understanding the stages of a job">
      Understanding the stages of a job
     </a>
    </p>
    <p class="toc-2-style">
     <a href="lexmark-document-distributor-overview.html#d0e118" title="Understanding the Lexmark Document Distributor system">
      Understanding the Lexmark Document Distributor system
     </a>
    </p>
    <p class="toc-2-style">
     <a href="lexmark-document-distributor-overview.html#security-overview" title="Security overview">
      Security overview
     </a>
    </p>
    <p class="toc-2-style">
     <a href="lexmark-document-distributor-overview.html#system-setup-overview" title="System setup overview">
      System setup overview
     </a>
    </p>
    <p class="toc-2-style">
     <a href="lexmark-document-distributor-overview.html#supported-printer-models" title="Supported printer models">
      Supported printer models
     </a>
    </p>
    <p class="toc-2-style">
     <a href="lexmark-document-distributor-overview.html#supported-prompts" title="Prompts supported by SFPs">
      Prompts supported by SFPs
     </a>
    </p>
    <p class="toc-2-style">
     <a href="lexmark-document-distributor-overview.html#double-byte-support" title="Double-byte character support">
      Double-byte character support
     </a>
    </p>
    <p class="toc-2-style">
     <a href="lexmark-document-distributor-overview.html#supported-ecm-platforms" title="Supported ECM software platforms">
      Supported ECM software platforms
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="installing-lexmark-document-distributor.html#installing-lexmark-document-distributor" title="Installing Lexmark Document Distributor">
     Installing Lexmark Document Distributor
    </a>
   </p>
   <div id="divd0e4760">
    <p class="toc-2-style">
     <a href="minimum-system-requirements-topic.html#minimum-system-requirements" title="System requirements">
      System requirements
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ports-used-by-ldd-system-topic.html#ports-used-by-ldd-system" title="Ports used by the LDD system">
      Ports used by the LDD system
     </a>
    </p>
    <p class="toc-2-style">
     <a href="obtaining-ldd-licenses-topic.html#obtaining-ldd-licenses" title="Obtaining licenses">
      Obtaining licenses
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-installation-types-topic.html#understanding-installation-types" title="Understanding installation types">
      Understanding installation types
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-firewall-access-LDD-topic.html#setting-up-firewall-access-LDD" title="Setting up firewall access for Firebird">
      Setting up firewall access for Firebird
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preparing-for-install-topic.html#preparing-for-install" title="Preparing for the installation">
      Preparing for the installation
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuration-type-workgroup-system-topic.html#d0e5622" title="Installing a workgroup system">
      Installing a workgroup system
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-enterprise-system.html#d0e5745" title="Installing an enterprise system">
      Installing an enterprise system
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-topic.html#managing-certificates" title="Managing certificates">
      Managing certificates
     </a>
    </p>
    <p class="toc-2-style">
     <a href="verifying-certificates-group.html#d0e6695" title="Verifying certificates">
      Verifying certificates
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-secure-connection-load-balancer-advanced-prompt-bundle-topic.html#configuring-secure-connection-load-balancer-advanced-prompt-bundle" title="Configuring secure connection to the load balancer in the Advanced Prompt bundle">
      Configuring secure connection to the load balancer in the Advanced
Prompt bundle
     </a>
    </p>
    <p class="toc-2-style">
     <a href="antivirus-policy-requirements-recommendations-topic.html#antivirus-policy-requirements-recommendations" title="Antivirus policy requirements and recommendations">
      Antivirus policy requirements and recommendations
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-ldd-components-silently-topic.html#installing-ldd-components-silently" title="Installing LDD components silently">
      Installing LDD components silently
     </a>
    </p>
    <p class="toc-2-style">
     <a href="upgrading-to-ldd-4.9-topic.html#upgrading-to-ldd-4.9" title="Upgrading the LDD system">
      Upgrading the LDD system
     </a>
    </p>
    <p class="toc-2-style">
     <a href="overview-kerberos-authentication-topic.html#d0e7062" title="Configuring Kerberos authentication">
      Configuring Kerberos authentication
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-lexmark-keep-alive-service-topic.html#installing-lexmark-keep-alive-service" title="Installing the Lexmark Keep Alive service">
      Installing the Lexmark Keep Alive service
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessing-lexmark-keep-alive-service-topic.html#accessing-lexmark-keep-alive-service" title="Accessing Lexmark Keep Alive service">
      Accessing Lexmark Keep Alive service
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-servers-using-API-topic.html#configuring-servers-using-API" title="Configuring the servers using API">
      Configuring the servers using API
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintaining-system.html#maintaining-system" title="Monitoring and maintaining the system">
     Monitoring and maintaining the system
    </a>
   </p>
   <div id="divd0e7434">
    <p class="toc-2-style">
     <a href="setting-up-adfs-sso-for-ldd-topic.html#setting-up-adfs-sso-for-ldd" title="Setting up AD FS Single Sign-On for LDD">
      Setting up AD FS Single Sign-On for LDD
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessing-lexmark-management-console-topic.html#d0e7617" title="Configuring Lexmark Management Console">
      Configuring Lexmark Management Console
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-home-tab.html#d0e8538" title="Finding basic information">
      Finding basic information
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-and-changing-server-status-topic.html#d0e8933" title="Managing the LDD system">
      Managing the LDD system
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessing-system-health-dashboard-topic.html#d0e9535" title="Managing system performance">
      Managing system performance
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-connection-to-smtp-server-topic.html#d0e9906" title="Configuring communications">
      Configuring communications
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-license-to-existing-server-topic.html#d0e10220" title="Managing licenses">
      Managing licenses
     </a>
    </p>
    <p class="toc-2-style">
     <a href="running-report-topic.html#d0e10256" title="Managing reports">
      Managing reports
     </a>
    </p>
    <p class="toc-2-style">
     <a href="group-backup-and-disaster-recovery.html#d0e11002" title="Backup and disaster recovery">
      Backup and disaster recovery
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-scripts-topic.html#scheduling-scripts" title="Scheduling scripts">
      Scheduling scripts
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="chapter-managing-solutions.html#chapter-managing-solutions" title="Managing solutions">
     Managing solutions
    </a>
   </p>
   <div id="divd0e11518">
    <p class="toc-2-style">
     <a href="understanding-solution-deployment-process-topic.html#understanding-solution-deployment-process" title="Deployment process overview">
      Deployment process overview
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-security-setup-configuration-files-for-e-task-5-printers-topic.html#understanding-security-setup-configuration-files-for-e-task-5-printers" title="Understanding security setup configuration files for e-Task 5 printers">
      Understanding security setup configuration files for e-Task 5 printers
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-solution-cSF-app-settings-topic.html#understanding-solution-cSF-app-settings" title="Understanding solution settings">
      Understanding solution settings
     </a>
    </p>
    <p class="toc-2-style">
     <a href="uploading-solutions-to-ldd-system-topic.html#uploading-solutions-to-ldd-system" title="Uploading solutions to the LDD system">
      Uploading solutions to the LDD system
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-global-solution-settings-topic.html#configuring-global-solution-settings" title="Configuring global solution settings">
      Configuring global solution settings
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-local-settings-for-deployed-solution-topic.html#configuring-local-settings-for-deployed-solution" title="Configuring local settings for a deployed solution">
      Configuring local settings for a deployed solution
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-esf-application-associatied-with-solution-topic.html#configuring-esf-application-associatied-with-solution" title="Configuring an eSF application associated with a solution">
      Configuring an eSF application associated with a solution
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-solution-related-files-topic.html#managing-solution-related-files" title="Locating solution-related files">
      Locating solution-related files
     </a>
    </p>
    <p class="toc-2-style">
     <a href="removing-solutions-topic.html#removing-solutions" title="Removing solutions">
      Removing solutions
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="chapter-managing-device-groups-and-devices.html#chapter-managing-device-groups-and-devices" title="Managing device groups and devices">
     Managing device groups and devices
    </a>
   </p>
   <div id="divd0e12191">
    <p class="toc-2-style">
     <a href="creating-and-populating-device-groups.html#d0e12194" title="Creating and populating device groups">
      Creating and populating device groups
     </a>
    </p>
    <p class="toc-2-style">
     <a href="deploying-solutions-to-device-group-topic.html#deploying-solutions-to-device-group-" title="Deploying solutions to a device group">
      Deploying solutions to a device group
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-for-device-group-topic.html#customizing-home-screen-for-device-group" title="Customizing the home screen for a device group">
      Customizing the home screen for a device group
     </a>
    </p>
    <p class="toc-2-style">
     <a href="updating-policies-for-device-groups-topic.html#updating-policies-for-device-groups" title="Updating policies for device groups">
      Updating policies for device groups
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-policy-updates-topic.html#scheduling-policy-updates" title="Scheduling policy updates">
      Scheduling policy updates
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-secure-communication-between-servers-printers-in-device-group-topic.html#enabling-secure-communication-between-servers-printers-in-device-group" title="Enabling secure communication between servers and printers in a device group">
      Enabling secure communication between servers and printers in a device group
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-validation-of-esf-application-deployment-topic.html#disabling-validation-of-esf-application-deployment" title="Disabling the validation of eSF application deployment">
      Disabling the validation of eSF application deployment
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-print-queue-topic.html#configuring-print-queue" title="Configuring the print queue">
      Configuring the print queue
     </a>
    </p>
    <p class="toc-2-style">
     <a href="searching-for-devices-topic.html#d0e13270" title="Configuring the Devices tab">
      Configuring the Devices tab
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="chapter-managing-software-clients.html#chapter-managing-software-clients" title="Managing software clients">
     Managing software clients
    </a>
   </p>
   <div id="divd0e13661">
    <p class="toc-2-style">
     <a href="understanding-software-clients-and-software-client-groups-topic.html#understanding-software-clients-and-software-client-groups" title="Understanding software clients and software client groups">
      Understanding software clients and software client groups
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-dynamic-prompting-support-topic.html#understanding-dynamic-prompting-support" title="Understanding dynamic prompting support">
      Understanding dynamic prompting support
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-software-client-setup-topic.html#understanding-software-client-setup" title="Software client setup overview">
      Software client setup overview
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-software-client-group-topic.html#d0e13791" title="Creating and populating software client groups">
      Creating and populating software client groups
     </a>
    </p>
    <p class="toc-2-style">
     <a href="assigning-solutions-to-software-client-group-topic.html#assigning-solutions-to-software-client-group" title="Assigning solutions to a software client group">
      Assigning solutions to a software client group
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-client-software-topic.html#installing-client-software" title="Installing client software">
      Installing client software
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-client-software-with-secure-print-support-topic.html#installing-client-software-with-secure-print-support" title="Installing client software with secure print support">
      Installing client software with secure print support
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-client-software-on-microsoft-cluster-server-topic.html#installing-client-software-on-microsoft-cluster-server" title="Installing client software on a Microsoft Cluster Server">
      Installing client software on a Microsoft Cluster Server
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-client-software-ports-topic.html#configuring-client-software-ports" title="Configuring client software ports">
      Configuring client software ports
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-ldd-printers-on-client-workstation-or-print-server-topic.html#adding-ldd-printers-on-client-workstation-or-print-server" title="Adding LDD printers on a client workstation or print server">
      Adding LDD printers on a client workstation or print server
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-lexmark-document-server-port-topic.html#configuring-lexmark-document-server-port" title="Configuring a Lexmark Document Server port">
      Configuring a Lexmark Document Server port
     </a>
    </p>
    <p class="toc-2-style">
     <a href="increasing-LDD-print-queue-availability-topic.html#increasing-LDD-print-queue-availability" title="Increasing LDD print queue availability">
      Increasing LDD print queue availability
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="using-ldd-solutions.html#using-ldd-solutions" title="Testing and using Lexmark Document Distributor solutions">
     Testing and using Lexmark Document Distributor solutions
    </a>
   </p>
   <div id="divd0e14315">
    <p class="toc-2-style">
     <a href="launching-solution-from-printer-topic.html#launching-solution-from-printer" title="Launching a solution from a printer">
      Launching a solution from a printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-documents-using-ldd-print-queues-topic.html#printing-documents-using-ldd-print-queues" title="Printing documents by using LDD print queues">
      Printing documents by using LDD print queues
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-gui-microsoft-windows-application-software-select-n-send-topic.html#d0e14384" title="Configuring the Microsoft Windows application software Select'N'Send">
      Configuring the Microsoft Windows application software Select'N'Send
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-lexmark-job-router-service-topic.html#installing-lexmark-job-router-service" title="Installing the Lexmark Job Router service">
      Installing the Lexmark Job Router service
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-lexmark-job-router-service-for-secure-print-topic.html#installing-lexmark-job-router-service-for-secure-print" title="Installing the Lexmark Job Router Service for secure print">
      Installing the Lexmark Job Router Service for secure print
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="chapter-viewing-logs.html#chapter-viewing-logs" title="Viewing logs">
     Viewing logs
    </a>
   </p>
   <div id="divd0e14653">
    <p class="toc-2-style">
     <a href="viewing-installation-logs-topic.html#viewing-installation-logs" title="Viewing the installation logs">
      Viewing the installation logs
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-server-logs-topic.html#viewing-server-logs" title="Viewing the server logs">
      Viewing the server logs
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-embedded-solutions-diagnostic-log-topic.html#viewing-embedded-solutions-diagnostic-log" title="Viewing the Embedded Solutions diagnostic log">
      Viewing the Embedded Solutions diagnostic log
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="chapter-troubleshooting.html#chapter-troubleshooting" title="Troubleshooting">
     Troubleshooting
    </a>
   </p>
   <div id="divd0e14790">
    <p class="toc-2-style">
     <a href="certificate-error-shows-when-accessing-lmc-topic.html#d0e14793" title="Solving LMC problems">
      Solving LMC problems
     </a>
    </p>
    <p class="toc-2-style">
     <a href="discovery-and-policy-updates-running-slowly-topic.html#d0e15090" title="Solving discovery problems">
      Solving discovery problems
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cannot-connect-to-Microsoft-SQL-Server-database-using-Windows-integrated-security-topic.html#d0e15244" title="Solving server and printer problems">
      Solving server and printer problems
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-cannot-create-lexmark-document-server-port-topic.html#d0e16148" title="Solving client software problems">
      Solving client software problems
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="notices.html#notices" title="Notices">
     Notices
    </a>
   </p>
   <div id="divd0e16331">
    <p class="toc-2-style">
     <a href="notices.html#d0e16334" title="Edition notice">
      Edition notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="notices.html#trademarks" title="Trademarks">
      Trademarks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="notices.html#us-government-rights" title="GOVERNMENT END USERS">
      GOVERNMENT END USERS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="notices.html#apache-license-one" title="The Apache Software License, Version 1.1">
      The Apache Software License, Version 1.1
     </a>
    </p>
    <p class="toc-2-style">
     <a href="notices.html#apache-license-2" title="Apache License Version 2.0, January 2004">
      Apache License Version 2.0, January 2004
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue